import * as React from "react";
import { cn } from "../../utils/cn";

export const Table = React.forwardRef(({ className, children, ...props }, ref) => (
  <div className={cn("w-full overflow-hidden rounded-md border", className)} ref={ref} {...props}>
    <table className="w-full">{children}</table>
  </div>
));
Table.displayName = "Table";

export const TableHeader = ({ children, className, ...props }) => (
  <thead className={cn("bg-muted text-muted-foreground", className)} {...props}>
    {children}
  </thead>
);
TableHeader.displayName = "TableHeader";

export const TableBody = ({ children, className, ...props }) => (
  <tbody className={cn("bg-background", className)} {...props}>
    {children}
  </tbody>
);
TableBody.displayName = "TableBody";

export const TableRow = ({ children, className, ...props }) => (
  <tr className={cn("border-b last:border-b-0", className)} {...props}>
    {children}
  </tr>
);
TableRow.displayName = "TableRow";

export const TableHead = ({ children, className, ...props }) => (
  <th scope="col" className={cn("px-4 py-3 text-left text-sm font-medium text-muted-foreground", className)} {...props}>
    {children}
  </th>
);
TableHead.displayName = "TableHead";

export const TableCell = ({ children, className, ...props }) => (
  <td className={cn("px-4 py-3 text-sm", className)} {...props}>
    {children}
  </td>
);
TableCell.displayName = "TableCell";

export default Table;
